'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './admin-dashboard.routes';

export class AdminDashboardComponent {
  constructor(Config, EFormsService, SurveysService, SettingsService) {
    'ngInject';
    this.newsTypes = Config.getModuleConfig(Config.Modules.News).getTypes();
    this.defaultNewsType = Config.getModuleConfig(Config.Modules.News).getDefaultType();
    this.eventTypes = Config.getModuleConfig(Config.Modules.Calendar).getEventTypes();
    this.galleryTypes = Config.getModuleConfig(Config.Modules.Gallery).getTypes();

    let docTypes = Config.getModuleConfig(Config.Modules.Document).getTypes();
    this.docPageTypes = Config.getModuleConfig(Config.Modules.Document).getPageCategories();

    SettingsService.getByName({name: 'account-request-config'}, setting => {
      this.accountRequestTypes = setting.data.types;
    }, _ => {
      this.accountRequestTypes = [];
    });

    this.widgets = [];

    SettingsService.getByName({name: 'admin-dashboard'}, widgets => {
      this.widgets = widgets.data;

      this.widgets.forEach(widget => {

        switch(widget.widget) {
          case "EFORM":
            EFormsService.query(data => {
              this.eforms = data;
            });
            break;
          case "SURVEY":
            SurveysService.query(data => {
              this.surveys = data;
            });
            break;
          case "RESERVATION":
            this.reservations =  Config.getModuleConfig(Config.Modules.Reservation).getTypes();
            break;
        }

      });

    });

    if (this.docPageTypes && Object.keys(this.docPageTypes).length) {
      this.docPages = Object.keys(this.docPageTypes);
    } else {
      this.docPages = ["general"];
      this.docPageTypes = {'general': []};
      this.docPageTypes['general'] = docTypes;
    }
  }
}

export default angular.module('coduuApp.admin.dashboard', [uiRouter])
  .config(routes)
  .component('adminDashboard', {
    template: require('./admin-dashboard.html'),
    controller: AdminDashboardComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/admin/dashboard/admin-dashboard.component.js